import styles from "./Presentation.module.css";
import EndPollModal from "../../components/modals/EndPollModal";
import PollTimeLimitModal from "../../components/modals/PollTimeLimitModal";
import React, {useState} from "react";
import {
    POLL_SHARE_MODE,
    POLL_TYPE,
    RELEASE_ACTIVITY_VIEW,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {removePrefixNew} from "../../utils/helpers";
import {PollApiCalls} from "../../apis/PollApiCalls";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import ViewActivityInfoIcon from "../ReleaseActivityPage/ViewActivityInfoIcon";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as SQUARE_ICON} from "../ReleaseActivityPage/images/square.svg";
import {LatexHTMLInline} from "../../components/Tiptap/latexParser";
import SAQuestion from "../../questions/SA/SAQuestion";

export default function ViewPresentAttendance({pollData, localState, setLocalState, resetPollData, userSettings}) {
    const { t } = useTranslation();
    const {poll, questions=[]} = pollData;
    const {pk, sk} = poll;
    let pollKey = removePrefixNew(pk);
    let pollCode = removePrefixNew(sk);

    const { shareQuestion, stopQuestion, updatePollDetails, updateQuestionDetails} = PollApiCalls();
    // const {createGradeColumn} = LTIApiCalls();

    const [endPollModalShow, setEndPollModalShow] = useState(false);
    const [showPollTimeLimitModal, setShowPollTimeLimitModal] = useState(false);
    const [mapInitialized, setMapInitialized] = useState(false);



    let isSharing =localState === "GET_READY" || localState === "SHARED";

    const handleStop = async (isEndPoll=false) => {
        await stopQuestion(pollKey, pollCode, 1, poll.pollType, isEndPoll);
        resetPollData((isEndPoll || poll.pollType === POLL_TYPE.ATTENDANCE) ? RELEASE_ACTIVITY_VIEW.METRIC_VIEW : null);
    };


    const handleOpen = async (timeLimit=0) => {
        let manualEnd = !timeLimit; // no get ready time limit for attendance

        const pollDetails = {};
        pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_EACH;
        pollDetails.endTime = !!timeLimit ? new Date(Date.now() + timeLimit * 1000) : "";
        pollDetails.manualEnd = manualEnd;
        pollDetails.attendanceDuration = timeLimit;
        await updatePollDetails(pollKey, pollCode, pollDetails, true);
        await updateQuestionDetails(pollKey, pollCode, 1, {timeLimit: timeLimit});


        await shareQuestion(pollKey, pollCode, 1, POLL_TYPE.ATTENDANCE);
        // createGradeColumn(pollKey, pollCode);
        setLocalState('SHARED');
        resetPollData();

    };

    return (
        <div className={`${styles.rightPart} ${styles.column}`} style={{gap: 15}}>
            <EndPollModal
                show={endPollModalShow}
                setModalShow={setEndPollModalShow}
                localState={localState}
                poll={poll}
                handleStop={handleStop}
                handleStopAll={() => {
                }}
            />

            <PollTimeLimitModal
                show={showPollTimeLimitModal}
                setShow={setShowPollTimeLimitModal}
                pollData={pollData}
                handleShareAll={() => {
                }}
                handleOpen={handleOpen}
                userSettings={userSettings}
            />

            <div className={styles.row}>
                <div className={styles.row} style={{gap: 7, flex: 1, minWidth: 120, marginRight: 10}}>
                    <span className={classes.pollTitleText}>{poll.pollTitle}</span>
                    <ViewActivityInfoIcon pollData={pollData}/>
                </div>


                {isSharing
                    ? <YuJaButton
                        tabIndex={0}
                        type={"delete"}
                        onClick={() => setEndPollModalShow(true)}
                        style={{width: 160, height: 40}}
                    >
                        <SQUARE_ICON style={{marginRight: 5}}/>
                        {t('common.finish')}
                    </YuJaButton>

                    : <div
                        tabIndex={0}
                        className={styles.releaseBtn}
                        onClick={() => setShowPollTimeLimitModal(true)}
                    >
                        {!!questions.filter(q => !!q.shareCount).length ? t('questionBuilder.releaseAgainButton') : t('questionBuilder.releaseAttendanceButton')}
                    </div>
                }

            </div>

                <div
                    className={classes.row}
                    style={{alignItems: "start", gap: 20, flex: 1,
                        minHeight: 0, overflowY: "auto",}}
                >
                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                        <span
                            style={{
                                fontWeight: "500",
                                color: "#000",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            <LatexHTMLInline>{questions[0]?.queTitle}</LatexHTMLInline>
                        </span>
                        <div style={{height: 20}}/>

                        <span>
                            {!!questions[0]?.correctAnswers ? questions[0]?.correctAnswers[0] : ""}
                        </span>
                    </div>

                    <div className={classes.column} style={{width: 350}}>
                        <SAQuestion
                            questions={questions}
                            setQuestions={() => {
                            }}
                            mapInitialized={mapInitialized}
                            setMapInitialized={setMapInitialized}
                            geofence={poll.geofence}
                            setGeofence={() => {
                            }}
                            syncLms={poll.syncLms}
                            setSyncLms={() => {
                            }}
                            selectedQuestion={questions[0]}
                            pollType={poll.pollType}
                            mapView={true}
                            questionBuilder={false}
                            editable={false}
                            userSettings={{}}
                        />
                    </div>
                </div>

        </div>
    );
}